// components/SkeletonSidebar.jsx
import Skeleton from "react-loading-skeleton";

const SkeletonSidebar = () => {
  return (
    <>
      {/* Sidebar Info */}
      <div className="sidebar-info">
        <figure className="avatar-box">
          <Skeleton circle width={80} height={80} />
        </figure>
        <div className="info-content">
          <h1 className="name">
            <Skeleton width={120} height={24} />
          </h1>
          <p className="title">
            <Skeleton width={80} height={18} />
          </p>
        </div>
        <button className="info_more-btn">
          <Skeleton width={100} height={24} />
        </button>
      </div>

      {/* Sidebar Contacts */}
      <div className="sidebar-info_more">
        <div className="separator"></div>
        <ul className="contacts-list">
          {Array(4)
            .fill(null)
            .map((_, idx) => (
              <li className="contact-item" key={idx}>
                <div className="icon-box">
                  <Skeleton circle width={24} height={24} />
                </div>
                <div className="contact-info">
                  <p className="contact-title">
                    <Skeleton width={60} height={14} />
                  </p>
                  <p className="contact-link">
                    <Skeleton width={100} height={14} />
                  </p>
                </div>
              </li>
            ))}
        </ul>

        {/* Social Links */}
        <div className="separator"></div>
        <ul className="social-list flex gap-2">
          {Array(5)
            .fill(null)
            .map((_, idx) => (
              <li className="social-item" key={idx}>
                <Skeleton circle width={30} height={30} />
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

export default SkeletonSidebar;
